
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorStaticHorisontal as ObiMotorStaticHorisontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-static-horisontal.js';
 
 
 

 
 export const ObiMotorStaticHorisontal = createComponent({
   react: React,
   tagName: 'obi-motor-static-horisontal',
   elementClass: ObiMotorStaticHorisontalElement,
   events: {
     
   }
  });
 
 